import {
  HorizontalTabs,
  HorizontalTabsButton,
  HorizontalTabsList,
  HorizontalTabsPanel,
  HorizontalTabsPanelList,
  Text,
} from '@cinch-labs/design-system'
import { useAnalytics } from '@cinch-nx/shared-analytics'
import React from 'react'
import { HomepageVehiclesData } from '../../../types/feature-home-page'
import { VehicleCondition } from '../../../types/vehicles-data'
import { PartExCta } from '../../part-ex-cta'
import { Filters } from '../filters/filters'
import { SearchCarsForm } from '../search-cars-form/search-cars-form'
import styles from './hero-tabs.module.css'
import { tabsNewCarsClickEvent, usedCarsTabClickEvent } from './tracking'

export interface HeroTabsProps {
  vehiclesData: HomepageVehiclesData
}

export const HeroTabs: React.FC<HeroTabsProps> = ({ vehiclesData }) => {
  const { trackEvent } = useAnalytics()

  return (
    <HorizontalTabs withBorder={true} activeTabId="button-id-1">
      <HorizontalTabsList ariaLabel="Find a car">
        <HorizontalTabsButton
          id="button-id-1"
          panelId="panel-id-1"
          onButtonClick={() => trackEvent(usedCarsTabClickEvent())}
        >
          <div className={styles.tabTitle}>Used cars</div>
        </HorizontalTabsButton>
        <HorizontalTabsButton
          id="button-id-2"
          panelId="panel-id-2"
          onButtonClick={() => trackEvent(tabsNewCarsClickEvent())}
        >
          <div className={styles.tabTitle}>New Cars</div>
        </HorizontalTabsButton>
      </HorizontalTabsList>

      <HorizontalTabsPanelList>
        <HorizontalTabsPanel
          buttonId="button-id-1"
          id="panel-id-1"
          className={styles.tabPanel}
        >
          <div className={styles.formTabContainer}>
            <Text element={'h1'} className={styles.heading}>
              Buy used cars online
            </Text>
            <Filters
              makes={vehiclesData.usedVehicles.makes}
              totalStock={vehiclesData.usedVehicles.totalStock}
            />
            <PartExCta trackingValue={VehicleCondition.Used} />
          </div>
        </HorizontalTabsPanel>
        <HorizontalTabsPanel
          buttonId="button-id-2"
          id="panel-id-2"
          className={styles.tabPanel}
        >
          <div className={styles.formTabContainer}>
            <Text element={'h1'} className={styles.heading}>
              Buy new cars online
            </Text>
            <SearchCarsForm
              vehicleData={vehiclesData.newVehicles}
              vehicleCondition={VehicleCondition.New}
            />
            <PartExCta trackingValue={VehicleCondition.New} />
          </div>
        </HorizontalTabsPanel>
      </HorizontalTabsPanelList>
    </HorizontalTabs>
  )
}
